import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";

export const areAllNodesDeselectedAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return nodes.every((node) => !node.selected);
});

areAllNodesDeselectedAtom.debugLabel = "areAllNodesDeselectedAtom";
